import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLink = styled.a`
  white-space: nowrap;
  font-size: 2rem;

  @media (max-width: 1025px) {
    font-size: 1rem;
  }
`;

const StyledHeader = styled.h1`
  letter-spacing: 10px;
`;

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="content">
      <div className="inner">
        <StyledHeader>HyperMed Technology</StyledHeader>
        <h3>A medical technology company based in San Diego and Las Vegas.</h3>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <StyledLink
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('rapid-detox');
            }}
          >
            Rapid Detox
          </StyledLink>
        </li>
        <li>
          <StyledLink
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('hyperthermia-treatment');
            }}
          >
            Hyperthermia Treatment
          </StyledLink>
        </li>
        <li>
          <StyledLink
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('cool-head');
            }}
          >
            Cool-Head Device
          </StyledLink>
        </li>
        <li>
          <StyledLink
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('uvg');
            }}
          >
            UV Germicidal Device
          </StyledLink>
        </li>
        <li>
          <StyledLink
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('contact');
            }}
          >
            Contact Us
          </StyledLink>
        </li>
      </ul>
    </nav>
  </header>
);

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
};

export default Header;
